import { useState, useEffect } from 'react';

/**
 * usePersistentState
 *
 * Drop-in replacement for useState that automatically persists its value in
 * localStorage. On mount the stored value is read synchronously (lazy init),
 * so the component never renders with the wrong initial value.
 *
 * @param {string} key           - localStorage key
 * @param {*}      defaultValue  - value to use when nothing is stored yet
 */
export function usePersistentState(key, defaultValue) {
  const [state, setState] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch {
      /* localStorage unavailable — no-op */
    }
  }, [key, state]);

  return [state, setState];
}
